const soundDementia = async() => {
  const path = `../assets/sound/extend/dementia.m4a`;    
  var audio = new Audio(path);
  audio.play();
}

export default soundDementia;